import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import { Button, Modal } from "../../components/design";
import "./RenewExitConfirm.css";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => Promise<void> | void;
};

export default function RenewExitConfirm({ open, onClose, onConfirm }: Props) {
  const [exiting, setExiting] = useState(false);
  const navigate = useNavigate();
  const { _t } = useTranslator();

  const handleExit = async () => {
    if (exiting) return;
    setExiting(true);
    try {
      if (onConfirm) await onConfirm();
    } catch (e) {
      console.error("Exit confirm failed", e);
    } finally {
      setExiting(false);
      navigate("/home");
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      title={_t("exitForNow", "Exit for now?")}
      description={_t(
        "exitRenewDescription",
        "Your progress is saved. Your profile will stay expired until you finish updating it."
      )}
      actions={
        <>
          <Button variant="secondary" size="lg" onClick={onClose}>
            {_t("keepGoing", "Keep going")}
          </Button>
          <Button size="lg" onClick={handleExit} loading={exiting}>
            {_t("exit", "Exit")}
          </Button>
        </>
      }
    />
  );
}
